import "./selectWithFiltering.scss";
import {
  ABTestPublishedStatus,
  AutomationStatus,
  BackgroundStyle,
  CommunicationActivityStatus,
  CommunicationPublishedStatus,
  StandardStatus,
  SubscriptionGDPRStatus,
} from "../../js/enums";
import Badge from "./Badge";

function StatusBadge({ enumList, value }) {
  const getStatusBadge = () => {
    switch (enumList) {
      case ABTestPublishedStatus:
        const abTestPublishedStatusText =
          value && value > 0
            ? String(
                Object.keys(ABTestPublishedStatus).find(
                  (key) => ABTestPublishedStatus[key] === value
                )
              )
            : "";
        return abTestPublishedStatusText ? (
          <Badge
            backgroundStyle={
              abTestPublishedStatusText === "Published"
                ? BackgroundStyle.Success
                : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: abTestPublishedStatusText }}
          />
        ) : (
          ""
        );
      case AutomationStatus:
        const automationStatusText =
          value !== null && value !== undefined && value >= 0
            ? String(
                Object.keys(AutomationStatus).find(
                  (key) => AutomationStatus[key] === value
                )
              )
            : "";
        return automationStatusText ? (
          <Badge
            backgroundStyle={
              automationStatusText === "Published"
                ? BackgroundStyle.Success
                : automationStatusText === "Testing"
                  ? BackgroundStyle.Warning
                : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: automationStatusText }}
          />
        ) : (
          ""
        );
      case CommunicationActivityStatus:
        const commActivityText =
          value !== null && value !== undefined && value >= 0
            ? String(
                Object.keys(CommunicationActivityStatus).find(
                  (key) => CommunicationActivityStatus[key] === value
                )
              )
            : "";
        return commActivityText ? (
          <Badge
            backgroundStyle={
              commActivityText === "Completed"
                ? BackgroundStyle.Success
                : commActivityText === "Cancelled"
                  ? BackgroundStyle.Danger
                  : commActivityText === "Scheduled"
                    ? BackgroundStyle.Warning
                    : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: commActivityText }}
          />
        ) : (
          ""
        );
      case CommunicationPublishedStatus:
        const communicationPublishedStatusText =
          value && value > 0
            ? String(
                Object.keys(CommunicationPublishedStatus).find(
                  (key) => CommunicationPublishedStatus[key] === value
                )
              )
            : "";
        return communicationPublishedStatusText ? (
          <Badge
            backgroundStyle={
              communicationPublishedStatusText === "Published"
                ? BackgroundStyle.Success
                : communicationPublishedStatusText === "Inactive"
                  ? BackgroundStyle.Danger
                  : communicationPublishedStatusText === "Testing"
                    ? BackgroundStyle.Warning
                    : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: communicationPublishedStatusText }}
          />
        ) : (
          ""
        );
      case StandardStatus:
        const standardStatusText =
          value !== null && value !== undefined && value >= 0
            ? String(
                Object.keys(StandardStatus).find(
                  (key) => StandardStatus[key] === value
                )
              )
            : "";
        return standardStatusText ? (
          <Badge
            backgroundStyle={
              standardStatusText === "Active"
                ? BackgroundStyle.Success
                : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: standardStatusText }}
          />
        ) : (
          ""
        );
      case SubscriptionGDPRStatus:
        const subscriptionGDPRStatusText = String(
          Object.keys(SubscriptionGDPRStatus).find(
            (key) => SubscriptionGDPRStatus[key] === value
          )
        );
        return subscriptionGDPRStatusText ? (
          <Badge
            backgroundStyle={
              subscriptionGDPRStatusText === "Subscribe"
                ? BackgroundStyle.Success
                : subscriptionGDPRStatusText === "Unsubscribe"
                  ? BackgroundStyle.Danger
                  : BackgroundStyle.Info
            }
            className="me-2"
            item={{ text: subscriptionGDPRStatusText }}
          />
        ) : (
          ""
        );
      default:
        return "";
    }
  };

  return getStatusBadge();
}

export default StatusBadge;
